import type { Reason } from '../types/content'

export const reasonsIntro =
  'Porque cuando se trata de temas personales y espirituales, la experiencia, la privacidad y la atención personalizada son importantes.'

export const reasons: Reason[] = [
  {
    id: 'trayectoria',
    title: 'Más de 45 años de trayectoria',
    text: 'Más de 45 años de trayectoria en prácticas espirituales y tradicionales.',
    icon: 'clock',
  },
  {
    id: 'consultas',
    title: 'Consultas y trabajos realizados',
    text: 'Más de 10.000 consultas y trabajos realizados a lo largo de nuestra trayectoria.',
    icon: 'archive',
  },
  {
    id: 'profesionalismo',
    title: 'Profesionalismo y atención personalizada',
    text: 'Cada consulta se realiza de manera personalizada y con respeto por la privacidad de cada persona.',
    icon: 'user',
  },
  {
    id: 'secreto',
    title: 'Secreto absoluto',
    text: 'Tratamos cada consulta con privacidad y discreción.',
    icon: 'lock',
  },
  {
    id: 'atencion',
    title: 'Trayectoria y cercanía',
    text: 'Trayectoria y atención personalizada para personas interesadas en orientación espiritual y prácticas tradicionales.',
    icon: 'compass',
  },
  {
    id: 'contacto',
    title: 'Consulta personalizada',
    text: 'Si buscas una consulta espiritual personalizada, puedes comunicarte con nosotros para conocer nuestros servicios.',
    icon: 'message',
  },
]
